import { FormProps } from "@rjsf/core";
import React, { Fragment, useMemo } from "react";
import { JsonSchemaConfiguration } from "../configurations/JsonSchemaFormConfiguration";
import { SCHEMEA_NS_KEY } from "../constants/Translation";
import { useSchemaContext } from "../context/SchemaContext";
import { FormContextMapper, IFormContext } from "../models/IFormContext";
import { IFormData, IFormSchema } from "../models/IFormSchema";
import { contextSchema as DefaultContextSchema, ISchemaContext } from "../models/ISchemaContext";
import composeRules from "../utils/composeRules";
import { getSchemaActionTypes } from "../utils/getSchemaActionTypes";
import { EWidgetType } from "../utils/widgetRegistry";

interface DisplayViewProps<T = IFormData> {
    formSchema: IFormSchema;
    formData: IFormData;
    contextSchema?: IFormSchema["schema"];
    contextData?: ISchemaContext;
    extraActions?: { [key: string]: any };
    configurations: JsonSchemaConfiguration;
    formContext?: IFormContext;
}

export const DisplayView: React.FC<DisplayViewProps> = ({
    formSchema,
    formData,
    formContext,
    contextData,
    contextSchema = DefaultContextSchema,
    extraActions,
    configurations,
    ...otherProps
}) => {
    const { translations } = formSchema;
    const { translate, addTranslationResource } = useSchemaContext() || {};

    const Form = useMemo(() => configurations.getForm(EWidgetType.Read), []);


    // If there's translations, add them to the namespace
    if (translations) {
        const keys = Object.keys(translations);
        keys.forEach((key) => {
            addTranslationResource(key, SCHEMEA_NS_KEY, translations[key]);
        });
    };

    const neutralizedAxtraActions = useMemo(() => {
        const actionTypes = getSchemaActionTypes(formSchema);
        const skipActions = ["remove", "require", "uiReplace", "uiOverride", "uiAppend"]
        const baseActions = actionTypes.reduce<{ [key: string]: any }>((acc, type) => {

            if (!skipActions.includes(type)) {
                return ({ ...acc, [type]: (extraActions || {})[type] || (() => { }) })
            }
            return acc
        }, {});
        return { ...baseActions, ...(extraActions || {}) };
    }, []);


    return (
        <Fragment>
            <Form
                {...otherProps}
                className="ui form SchemaDisplay"


                formSchema={formSchema}
                formData={formData}
                formContext={{ ...formContext, mode: "display" }}

                noHtml5Validate={true}
                liveValidate={false}

                contextData={contextData}
                contextSchema={contextSchema}
                extraActions={neutralizedAxtraActions}
                children={<span />}
            />
        </Fragment>
    );
};